import React, { Component, useEffect, useState } from 'react'
import '../../App.css'
import { Container, Row, Col, Dropdown } from 'react-bootstrap'
import Axios from 'axios'
import ReactTooltip from 'react-tooltip'
import { IoIosAddCircle, IoIosCheckmark } from 'react-icons/io'
import { BsCCircle, BsClockFill, BsFillCircleFill } from 'react-icons/bs'
import { BiCheckCircle, BiCircle, BiErrorAlt, BiHourglass, BiRefresh, BiSync } from 'react-icons/bi'
import { SiProcessingfoundation } from 'react-icons/si'
import { IoHourglassSharp, IoRefresh, IoSync } from 'react-icons/io5'
import FullPayoutModal from '../../modals/payouts/RequestPayoutModal'
import { formatZARCurrency } from '../../MoneyFormat'
import { API_URL } from '../../config'

const Summary = (props) => {
  const [confirmBtn, setConfirmBtn] = useState('save-btn text-bold')
  const [disabledBtn, setDisabledBtn] = useState(false)
  const [alertState, setAlertState] = useState('success-alert')
  const [resMessage, setResMessage] = React.useState('')
  const [errorDisplay, setErrorDisplay] = useState('d-none')
  const [payOutType, setPayOutType] = useState('')
  const [sales, setSales] = useState(0)
  const [net, setNet] = useState(0)
  const [gross, setGross] = useState(0)
  const [balance, setBalance] = useState(0)
  const [deduction, setDduction] = useState(0)
  const [budget, setBudget] = useState(0)
  const [eventEndDate, setEventEndDate] = useState('0000-00-00')
  const [payoutStatus, setPayoutStatus] = useState('No Activity')
  const [nextPayout, setNextPayout] = useState('0000-00-00')
  const [processingFees, setProcessingFees] = useState(0)
  const [amountRefunded, setAmountRefunded] = useState(0)
  const [count, setCount] = useState(0)
  const [refreshing, setRefreshing] = useState(false)
  const [status, setStatus] = useState('')
  const [physicalPlatformFeesDeduction, setPhysicalPlatformFeesDeduction] = useState(0)
  const [isSponsorship, setIsSponsorship] = useState(0)
  const [bookingFee, setBookingFee] = useState(0)
  const [payoutRequestAmount, setPayoutRequestAmount] = useState(0)

  const [message, setMessage] = useState('')
  const [clipLoading, setClipLoading] = useState(false)

  const [modalOpen, setModalOpen] = useState(false)

  const event_id = props.eventid
  useEffect(() => {
    const businessid = localStorage.getItem('businessid')
    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=PAYOUTSUMMARY&businessid=${businessid}&event_id=${event_id}`,
      {
        withCredentials: true,
      }
    )
      .then((response) => {
        const res = response.data.results[0]
        const responseData = response.data
        setPhysicalPlatformFeesDeduction(responseData.physical_fees_deduction ?? 0)
        setStatus(responseData.status)
        setSales(res.total_sales ?? 0.0)
        setNet(res.total_net ?? 0.0)
        setGross(res.gross_sales ?? 0.0)
        setBalance(res.total_budget_balance ?? 0.0)
        setDduction(res.total_fees_deduction ?? 0.0)
        setBudget(res.total_budget ?? 0.0)
        setEventEndDate(res.event_end_date ?? '0000-00-00')
        setPayoutStatus(res.payout_status ?? 'No Activity')
        setNextPayout(res.next_payout ?? '0000-00-00')
        setProcessingFees(res.gateway_processing_fee ?? 0.0)
        setAmountRefunded(responseData.amount_refunded ?? 0.0)
        setIsSponsorship(responseData.is_sponsorship ?? 0)
        setBookingFee(res.booking_fee ?? 0)
        setMessage(res.message ?? '')
        setPayoutRequestAmount(responseData.amountRequest ?? 0)
        setRefreshing(false)
      })
      .catch((error) => console.log(error))
  }, [count, props.count])

  const handlePayoutRequest = (amountRequested) => {
    const numericAmount = amountRequested
    if (!numericAmount || numericAmount <= 0) {
      setAlertState('error-alert')
      setResMessage('Enter a valid amount')
      setErrorDisplay('d-block')
      setModalOpen(false)
      setTimeout(() => {
        setErrorDisplay('d-none')
      }, 5000)
      return // optional validation
    }
    if (numericAmount > netPayout) {
      setAlertState('error-alert')
      setResMessage('Amount cannot exceed net payout')
      setErrorDisplay('d-block')
      setModalOpen(false)
      setTimeout(() => {
        setErrorDisplay('d-none')
      }, 5000)

      return
    }

    const data = new FormData()
    data.append('amountRequested', amountRequested)
    data.append('event_id', event_id)
    data.append('payout_type', payOutType)
    data.append('source', 'ORGANISER_PAYOUT')
    data.append('query', 'REQUESTPAYOUT')
    setClipLoading(true)
    setConfirmBtn('btn-disabled text-bold')
    setDisabledBtn(true)

    Axios({
      method: 'POST',
      url: `${API_URL}/apps/kscanner/webservices.php`,
      data: data,
      withCredentials: true,
    })
      .then((response) => {
        setCount(count + 1)
        const responseData = response.data
        console.log(responseData.status)
        if (responseData.status === 'success') {
          setResMessage(responseData.message)
          setAlertState('success-alert')
          setErrorDisplay('d-block')
          setModalOpen(false)

          setTimeout(() => {
            setErrorDisplay('d-none')
          }, 5000)
        } else {
          setAlertState('error-alert')
          setResMessage(responseData.message)
          setErrorDisplay('d-block')
          setModalOpen(false)
          setTimeout(() => {
            setErrorDisplay('d-none')
          }, 5000)
        }

        setClipLoading(false)
        setConfirmBtn('save-btn text-bold')
        setDisabledBtn(false)
      })
      .catch((error) => {
        setClipLoading(false)
        setConfirmBtn('save-btn text-bold')
        setDisabledBtn(false)
        alert(error)
        console.log(error)
      })
  }

  const today = new Date()
  const currentDate = today.toISOString().split('T')[0] // e.g., "2025-07-02"
  let isComplete

  if (currentDate > eventEndDate) {
    isComplete = (
      <span>
        {sales > 0 ? (
          <span>
            <BiCheckCircle size={20} color="green" />
            &nbsp;&nbsp;Completed
          </span>
        ) : (
          <span>
            <BiHourglass size={20} color="#5A7D9A" />
            &nbsp;&nbsp;Awaiting Sales
          </span>
        )}
      </span>
    )
  } else {
    isComplete = (
      <span>
        <BsFillCircleFill size={20} color="gold" />
        &nbsp;&nbsp;In Progress
      </span>
    )
  }
  let formattedDate = 'N/A'
  if (nextPayout !== '0000-00-00') {
    const dateObj = new Date(nextPayout) ?? new Date('0000-00-00')
    formattedDate = dateObj.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    })
  }

  let payout_status
  if (payoutStatus == 'Pending') {
    payout_status = (
      <span>
        <BsClockFill size={20} color="orange" />
        &nbsp;&nbsp;{payoutStatus}
      </span>
    )
  } else if (payoutStatus == 'Processing') {
    payout_status = (
      <span>
        <IoSync size={20} color="#2196f3" />
        &nbsp;&nbsp;{payoutStatus}
      </span>
    )
  } else if (payoutStatus == 'Failed') {
    payout_status = (
      <span>
        <BiErrorAlt size={20} color="#f44336" />
        &nbsp;&nbsp;{payoutStatus}
      </span>
    )
  } else {
    if (sales > 0) {
      payout_status = (
        <span>
          <BiCheckCircle size={20} color="#4caf50" />
          &nbsp;&nbsp;{payoutStatus}
        </span>
      )
    } else {
      payout_status = (
        <span>
          <BiCircle size={20} color="#5A7D9A" />
          &nbsp;&nbsp;{payoutStatus}
        </span>
      )
    }
  }

  const refreshView = () => {
    return (
      <label
        className="float-right refresh-btn"
        title="Update Summary"
        data-for="refreshSummary"
        data-tip="Update Summary"
        style={{ cursor: 'pointer', marginTop: '-10px' }}
        onClick={() => {
          setCount(count + 1)
          setRefreshing(true)
        }}
      >
        {refreshing ? 'Updating...' : ''} <BiRefresh size={30} />
        <ReactTooltip id="refreshSummary" place="top" type="dark" effect="solid" className="p-1" />
      </label>
    )
  }

  const requestPayout = (type) => {
    setPayOutType(type)
    setModalOpen(true)
  }

  const netPayout = Math.max(
    0,
    (Number(net) - Number(amountRefunded) - (isSponsorship == 1 ? 0 : 10)).toFixed(2)
  )

  return (
    <>
      <div className="col-12 mt-2 p-0">
        {sales > 0 ? (
          <div className="alert alert-success">
            <strong>Note:</strong> This payout summary updates in real-time as new sales are
            confirmed. <br />
            <label className="text-success">
              {currentDate > eventEndDate ? 'Sales are complete.' : 'Sales are in progress.'}
            </label>
            {refreshView()}
          </div>
        ) : (
          <div className="alert alert-info">
            <strong>Note:</strong> This payout summary updates in real-time as new sales are
            confirmed. <br />
            <label className="text-danger">
              {message ? message : 'No sales have been made yet.'}
            </label>
            {refreshView()}
          </div>
        )}
      </div>
      <div className="col-12 p-0">
        <div className="item-list w-100">
          <div className="row w-100">
            <div className="col-lg-6 col-12 p-0">
              <label className="ticket-title  pl-0 pr-0">
                <h5>Payout Summary</h5>
              </label>
            </div>
            <div className="col-lg-6 col-12 p-0 d-flex justify-content-start justify-content-lg-end">
              <Dropdown className="mb-3">
                <Dropdown.Toggle
                  variant={Number(netPayout).toFixed(2) <= 0 ? 'disabled' : 'info'}
                  id="dropdown-basic"
                  className="text-bold"
                  disabled={Number(netPayout).toFixed(2) <= 0 ? true : false}
                >
                  Request Payout - R{netPayout}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item
                    onClick={() => requestPayout('partial')}
                    className="text-decoration-none"
                  >
                    Partial payout
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => requestPayout('full')}
                    className="text-decoration-none"
                  >
                    Full payout - R{netPayout}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
        <FullPayoutModal
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          onConfirm={handlePayoutRequest}
          netPayout={netPayout}
          payOutType={payOutType}
          clipLoading={clipLoading}
          confirmBtn={confirmBtn}
          disabledBtn={disabledBtn}
          count={count}
          source={'organiserPayout'}
        />
      </div>

      <div className={status === 'failed' ? 'col-12 p-0' : 'd-none'}>
        <div className="table-responsive">
          {' '}
          <table className="table table-bordered">
            <tbody>
              <tr>
                <th className="td-bottom-line-map">Description</th>
                <th className="td-bottom-line-map">Amounts</th>
                <th className="td-bottom-line-map">Notes</th>
                <th className="td-bottom-line-map">Status</th>
              </tr>
              <tr>
                <td colSpan={4} className="td-bottom-line-map text-grey">
                  {message}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className={status === 'failed' ? 'd-none' : 'col-12 p-0'}>
        <div className="table-responsive">
          <table className="table table-bordered">
            <tbody>
              <tr>
                <th className="td-bottom-line-map">Description</th>
                <th className="td-bottom-line-map">Amounts</th>
                <th className="td-bottom-line-map">Notes</th>
                <th className="td-bottom-line-map">Status</th>
              </tr>
              <tr>
                <td className="td-bottom-line-map">
                  <span>Gross Ticket Sales</span>
                </td>
                <td className="td-bottom-line-map">{formatZARCurrency(gross.toString())}</td>
                <td className="td-bottom-line-map text-12">
                  Represents the cumulative revenue generated from all confirmed ticket sales before
                  any deductions.
                </td>
                <td className="td-bottom-line-map">{isComplete}</td>
              </tr>
              <tr className={isSponsorship == 1 ? 'd-none' : ''}>
                <td className="td-bottom-line-map">
                  <span>Prepaid Budget (Fees)</span>
                </td>
                <td className="td-bottom-line-map">R{budget}</td>
                <td className="td-bottom-line-map text-12">
                  The amount the organiser allocated upfront to cover platform fees for this event
                </td>
                <td className="td-bottom-line-map"></td>
              </tr>

              <tr className={isSponsorship == 1 ? 'd-none' : ''}>
                <td className="td-bottom-line-map">
                  <span>Fees Deducted (to date)</span>
                </td>
                <td className="td-bottom-line-map">
                  R{(Number(deduction) + Number(physicalPlatformFeesDeduction)).toFixed(2)}
                </td>
                <td className="td-bottom-line-map text-12">
                  A 3.5% platform service fee is auto-deducted per ticket sale,
                  <br />
                  plus R1.00 per physical ticket if applicable—subtracted from your prepaid budget.{' '}
                  <a href="/campaigns" target="_blank">
                    See campaigns
                  </a>
                </td>
                <td className="td-bottom-line-map"></td>
              </tr>
              <tr className={isSponsorship == 1 ? 'd-none' : ''}>
                <td className="td-bottom-line-map">
                  <span>Balance </span>
                </td>
                <td className="td-bottom-line-map">R{balance}</td>
                <td className="td-bottom-line-map text-12">
                  This is your net prepaid budget after deducting platform service fee, calculated
                  at (3.5%) per ticket sale, <br /> and R1.00 per printed ticket (If applicable).
                  Unused funds roll over and can be used for future events.
                </td>
                <td className="td-bottom-line-map"></td>
              </tr>
              <tr>
                <td className="td-bottom-line-map">
                  <span>Payout Fee</span>
                </td>
                <td className="td-bottom-line-map">
                  <label className={`${isSponsorship == 1 ? 'lineThrough' : ''} mb-0`}>
                    R10.00
                  </label>
                </td>
                <td className="td-bottom-line-map text-12">
                  A payout fee is a charge applied when funds are transferred from a platform to
                  your <br />
                  nominated bank account. This fee covers the costs associated with processing the
                  payout,
                  <br />
                  including bank transaction fees and administrative expenses.
                </td>
                <td className="td-bottom-line-map"></td>
              </tr>
              {/* <tr>
              <td className="td-bottom-line-map">
                <span>Booking Fees (Karamale)</span>
              </td>
              <td className="td-bottom-line-map">R{bookingFee}</td>
              <td className="td-bottom-line-map text-12">
                A service charge added on top of your ticket price during
                checkout. It's paid by the customer and does not <br /> affect
                your <span>net payout</span>. You receive the full ticket price
                you set x quantity sold.
              </td>
              <td className="td-bottom-line-map"></td>
            </tr> */}
              <tr>
                <td className="td-bottom-line-map">
                  <span>Approved Refunds</span>
                </td>
                <td className="td-bottom-line-map">
                  {formatZARCurrency(amountRefunded.toString())}
                </td>
                <td className="td-bottom-line-map text-12">
                  Approved refunds are refund requests that met your configured rules or Karamale's
                  default policy <br />
                  and were approved by you. These amounts have been deducted from your{' '}
                  <span>net payout</span>.
                </td>
                <td className="td-bottom-line-map"></td>
              </tr>
              <tr>
                <td className="td-bottom-line-map">
                  <span>Payouts Requested</span>
                </td>
                <td className="td-bottom-line-map">
                  {formatZARCurrency(payoutRequestAmount.toString())}
                </td>
                <td className="td-bottom-line-map text-12">
                  Reflects the total amount you've asked to withdraw from your{' '}
                  <span>net payout</span> availability.
                  <br />
                  These requests may still be pending, under review, or already paid. <br />
                  Until processed, requested payouts are temporarily deducted from your{' '}
                  <span>net payout</span> total.
                </td>
                <td className="td-bottom-line-map"></td>
              </tr>
              <tr>
                <td className="td-bottom-line-map">
                  <span>Net Payout Available</span>
                </td>
                <td className="td-bottom-line-map">{formatZARCurrency(netPayout.toString())}</td>
                <td className="td-bottom-line-map text-12">
                  This is the total amount you'll receive based on your ticket pricing x quantity
                  sold. <br />
                  The only deductions that affect this amount are <span>
                    approved refunds
                  </span>, <span>payouts requested</span> and the standard <span>payout fee.</span>
                  <br />
                  <br />
                  If your event is sponsored by <span>Karamale</span>, the <span>payout fee</span>{' '}
                  is waived—ensuring you receive the
                  <br /> full value of your net payout, minus any refunds you've approved.
                </td>
                <td className="td-bottom-line-map">
                  <span>{payout_status}</span>
                </td>
              </tr>
              {/* <tr>
              <td className="td-bottom-line-map">
                <span>Estimated Payout Date</span>
              </td>
              <td className="td-bottom-line-map">
                <span>{formattedDate}</span>
              </td>
              <td className="td-bottom-line-map text-12">
                Payouts are processed after the event ends and financials are
                reconciled. <br />
                Please allow 3 - 5 business days for bank processing or internal
                review.
              </td>
              <td className="td-bottom-line-map"></td>
            </tr> */}
              <tr>
                <td colSpan={4} className="td-bottom-line-map">
                  <span>Important:</span> All these figures update in real-time as new sales are
                  confirmed.
                </td>
              </tr>
              {/* <tr
              data-for="totalPayout"
              data-tip="This is the amount you'll receive in your bank account for the sales made so far."
            >
              <td className="td-bottom-line-map">
                <span>Total Payout</span>
              </td>
              <td className="td-bottom-line-map">R{net}</td>
            </tr> */}
            </tbody>
          </table>
        </div>
        <ReactTooltip id="budgetTip" place="top" type="dark" effect="solid" />
        <ReactTooltip id="feesDeduction" place="top" type="dark" effect="solid" />
        <ReactTooltip id="remainingBudget" place="top" type="dark" effect="solid" />
        <ReactTooltip id="netEarnings" place="top" type="dark" effect="solid" />
        <ReactTooltip id="totalPayout" place="top" type="dark" effect="solid" />
      </div>
      <div className={alertState + ' text-center ' + errorDisplay}>{resMessage}</div>
    </>
  )
}

export default Summary
